import {APIService} from '@/services/api.service';
import {ItineraryPreferencesState} from './itinerary-preferences-types';

export async function updateItineraryPreferences(
  userId: string,
  sessionId: string,
  itineraryPreferences: ItineraryPreferencesState,
): Promise<object> {
  try {
    const result = await APIService.post<object>(`session/planner-config`, itineraryPreferences, {
      params: {
        user_id: userId,
        session_id: sessionId,
      },
    });
    return result;
  } catch (e) {
    return [];
  }
}

export async function fetchItineraryPreferences(userId: string, sessionId: string): Promise<object> {
  try {
    const result = await APIService.get<object>(`session/planner-config`, {
      params: {
        user_id: userId,
        session_id: sessionId,
      },
    });
    return result;
  } catch (e) {
    return [];
  }
}
